import { useEffect, useRef } from 'react';

declare global {
  interface Window {
    Trustpilot?: { loadFromElement: (el: Element, force?: boolean) => void };
  }
}

/** Trustpilot "Review Collector" TrustBox widget */
export default function TrustpilotWidget() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (window.Trustpilot && ref.current) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, []);

  return (
    <div
      ref={ref}
      className="trustpilot-widget"
      data-locale="en-US"
      data-template-id="56278e9abfbbba0bdcd568bc"
      data-businessunit-id="6a43ced53c5432201687af82"
      data-style-height="52px"
      data-style-width="100%"
      data-token="7cc38c91-6077-4483-b662-eccd31a14891"
    >
      <a href="https://www.trustpilot.com/review/bigbirdtravel.com" target="_blank" rel="noopener noreferrer">
        Trustpilot
      </a>
    </div>
  );
}
